import { render, staticRenderFns } from "./scEmbed.vue?vue&type=template&id=68386ce4&scoped=true&"
import script from "./scEmbed.vue?vue&type=script&lang=js&"
export * from "./scEmbed.vue?vue&type=script&lang=js&"
import style0 from "./scEmbed.vue?vue&type=style&index=0&id=68386ce4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68386ce4",
  null
  
)

export default component.exports